module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-72x72-189ad0f1f044b8264a53c390831f4d51.png";